<template>
  <div>
    <basic-alert :active="alertActive" :type="alertType" :msg="alertMsg" />
    <view-container>
      <v-container>
        <v-row>
          <v-col cols="12" xl="12" md="12">
            <h2 v-text="'¡Hola, ' + profileName + '!'" />
            <br />
            <v-text-field
              class="rounded-0"
              single-line
              outlined
              color="primary"
              background-color="white"
              label="Buscar Region, Pais, Ubicacion"
              persistent-hint
              prepend-inner-icon="mdi-magnify"
              append-icon=""
              @input="getLocation()"
              v-model="text"
            />
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row>
          <v-col
            style="scroll-behavior: auto;"
            class="out-padding"
            cols="12"
            sm="12"
            md="12"
          >
            <auto-container
              :scrollY="text.length > 0 ? true : false"
              color="#F7F9F9"
              :dimension="'100'"
            >
              <div style="scroll-behavior: auto;">
                <h2
                  class="font-weight-medium text-center"
                  v-text="
                    text == ''
                      ? 'Lugar Más Cercano A Tu Ubicacion'
                      : 'Resultado de la busqueda'
                  "
                />
                <div v-for="location in locations" :key="location.key">
                  <Search-box v-if="text" :item="location" />
                </div>
                <Search-box
                  v-if="!text && locations.length"
                  :item="locations[0]"
                />
                <div class="itemsCenter" v-if="loading">
                  <v-progress-circular
                    :size="100"
                    :width="7"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </div>
            </auto-container>
          </v-col>
        </v-row>
      </v-container>
    </view-container>
  </div>
</template>

<script>
import {
  AutoContainer,
  ViewContainer,
  BasicInput,
  BasicBtn,
  SearchBox,
  InfoList,
  BasicAlert,
} from "@/components";
import { services } from "@/utils";
import moment from "moment";

export default {
  name: "home",
  components: {
    AutoContainer,
    ViewContainer,
    BasicInput,
    BasicBtn,
    SearchBox,
    InfoList,
    BasicAlert,
  },
  data: () => ({
    profileName: "Usuario",
    text: "",
    alertMsg: "",
    alertType: "success",
    loading: false,
    alertActive: false,
    locations: [],
    infoUser: [
      { title: "Nombre:", info: "Laura Ocampo" },
      { title: "Fecha:", info: "Mie 21 de Junio de 2021" },
      { title: "Hora de inicio:", info: "11:00h" },
      { title: "Personas:", info: "3" },
    ],
  }),
  mounted() {
    this.getLocation();
    this.dataProfile();
    if (this.$route.query.alertMsg) {
      this.alertActive = true;
      this.alertMsg = this.$route.query.alertMsg;
      this.alertType = this.$route.query.alertType;
    }
  },
  watch: {
    alertActive(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertActive = false;
        }, 3000);
      }
    },
  },
  methods: {
    getLocation() {
      this.loading = true;
      let fechaInicio = moment(new Date())
        .utc()
        .format("YYYY-MM-DD HH:mm");
      let fechaFin = moment(new Date())
        .endOf("day")
        .utc()
        .format("YYYY-MM-DD HH:mm");
      let data = {
        texto: this.text ? this.text : "",
        fechaInicio: fechaInicio,
        fechaFin: fechaFin,
      };
      services
        .ws("get", "locations", data, "params")
        .then((res) => {
          if (res.ok) {
            this.locations = res.data;
          } else {
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    dataProfile() {
      services
        .ws("get", "profile")
        .then((res) => {
          if (res.ok) {
            this.profileName = res.data.nombre + " " + res.data.apellidoPaterno;
          } else {
            this.logout();
          }
        })
        .catch((error) => {
          this.codeError = error.response.data.code;
          this.error = true;
          this.logout();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    logout() {
      if (this.$session.exists()) {
        let jwt = this.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        this.axios
          .post(services.routes.logout, null, { headers })
          .then((response) => {
            let res = response.data;
            this.$session.destroy();
            this.$router.push("/login");
          })
          .catch((error) => {
            this.$session.destroy();
            this.$router.push("");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$router.push("");
      }
    },
  },
};
</script>

<style scoped>
.padding-b0 {
  padding-bottom: 0px;
}
.padding-t0 {
  padding-top: 0px;
}
.padding-t10 {
  padding-top: 3%;
}
.alignText {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
h2 {
  color: #005591;
}
.one {
  display: flex !important;
  align-items: flex-end !important;
}
</style>
